import { backupRecords, chunks } from './baseStorage';

export interface BackupRecord {
  teamId?: string;
  folderId?: string;
  fileId: string;
  uploadId?: string;
  startedAt: number;
}

export const addBackupRecord = async (fileId: string, value: BackupRecord) => {
  await backupRecords.setItem(fileId, value);
};

export const getBackupRecords = async (teamId?: string) => {
  const rs = await (Promise.all(
    (await backupRecords.keys()).map((key) => backupRecords.getItem(key))
  ) as Promise<BackupRecord[]>);

  if (teamId) {
    return rs.filter((r) => r.teamId === teamId);
  }

  return rs;
};

export const deleteBackupRecord = async (fileId: string) => {
  await backupRecords.removeItem(fileId);
};

const makeChunkKey = (fileId: string, partNumber: number) => {
  return `${fileId}_${partNumber}`;
};

export const saveChunk = async (
  fileId: string,
  partNumber: number,
  value: any
) => {
  await chunks.setItem(makeChunkKey(fileId, partNumber), value);
};

export const loadChunk = async (fileId: string, partNumber: number) => {
  return chunks.getItem(makeChunkKey(fileId, partNumber)) as Promise<Blob>;
};

export const listChunks = async (fileId?: string) => {
  const keys = await chunks.keys();

  if (fileId) {
    return keys.filter((key) => key.startsWith(fileId));
  }

  return keys;
};

export const deleteChunks = async (fileId: string) => {
  const keys = await listChunks(fileId);
  await Promise.all(
    keys.map(async (key) => {
      await chunks.removeItem(key);
    })
  );
};
